export default "__VITE_ASSET__Du54Xd_Q__"